import { Link } from "react-router-dom";

function formatPct(value) {
  if (value == null || Number.isNaN(Number(value))) return "—";
  return `${Math.round(Number(value) * 100)}%`;
}

export default function PartnerInventoryRolloutReadinessTable({ rolloutReadiness, path }) {
  const dealers = rolloutReadiness?.dealers || [];
  const config = rolloutReadiness?.config;

  if (!dealers.length) {
    return <p className="muted">No dealer rollout data available yet.</p>;
  }

  return (
    <section className="partner-panel partner-inventory-rollout">
      <div className="partner-panel__header">
        <div>
          <h3>Grouped inventory rollout readiness</h3>
          <p className="muted">
            Stage: <strong>{config?.rolloutStage || "stage_0_internal"}</strong>
            {" · "}
            Grouped view {config?.groupedViewEnabled ? "enabled" : "disabled"}
            {" · "}
            Default grouped {config?.groupedViewDefaultEnabled ? "enabled" : "disabled"}
          </p>
        </div>
        <span className="muted">
          {rolloutReadiness?.totals?.groupedDefaultEligibleDealers || 0} of {dealers.length} dealers
          eligible for grouped default
        </span>
      </div>

      <div className="partner-health-table-wrap">
        <table className="partner-health-table">
          <thead>
            <tr>
              <th>Dealer</th>
              <th>Listings</th>
              <th>Make + Model</th>
              <th>Trim</th>
              <th>Needs review</th>
              <th>Health</th>
              <th>Grouped default</th>
              <th>Current default</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {dealers.map((dealer) => (
              <tr key={dealer.dealerId}>
                <td>
                  <strong>{dealer.businessName}</strong>
                  <span className="partner-health-table__meta">{dealer.dataSource}</span>
                </td>
                <td>{dealer.totalListings}</td>
                <td>{formatPct(dealer.makeModelCoverage)}</td>
                <td>{formatPct(dealer.trimCoverage)}</td>
                <td>
                  {dealer.needsReviewCount}
                  {dealer.totalListings
                    ? ` (${Math.round((dealer.needsReviewRate || 0) * 100)}%)`
                    : ""}
                </td>
                <td>{dealer.healthScore || "—"}</td>
                <td>{dealer.groupedDefaultEligible ? "Eligible" : "Not yet"}</td>
                <td>{dealer.currentDefault}</td>
                <td>
                  <Link
                    className="partner-health-action"
                    to={path(`dealers/${dealer.dealerId}/inventory`)}
                  >
                    Inventory
                  </Link>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
}
